import React from 'react';

export default function ({ highlightsfeed, eleRef }) {
    return (
        <section className="main_container_block_feeds">
                        <div className="main_block_container_feed">
                           <div className="block_container_feed_heading_text R15_61" role='heading' tabIndex={0} aria-label={highlightsfeed.title}>
                           {highlightsfeed.title?highlightsfeed.title:''}
                            </div>
                            <div className="content-div-box-artical">
                             <div className="groups_you_might_be_main"> 
                                <div className="content-div_view_artical">
                                  <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/groups_intrested.jpeg" alt="groups you might be interested in" title='groups you might be interested in'/>
                                </div>
                                <div className="groups_you_might">
                                   <div className="B16_42"> Friends Activity </div>
                                    <div className="baby-week-social-view social_padding_group"> 
                                        <div className="post-options">
                                          <div className="icon left devMemoLike font-sizeview" data-icon-font="$"> <span className="icons-text R13_42"> 124</span> </div>
                                          <div className="icon left" data-icon-font="e"> <span className="icons-text R13_42"> 10k Post </span> </div>
                                        </div>
                                       <div className="m-abuse-main right">
                                         <div className="icon left icon3dot" data-icon-font="?"> <span className="icons-text font-sizeview_user R13_42"> 5k Members </span></div>
                                       </div>
                                   </div>
                                </div>
                            <div className="groups_you_might_join"> 
                               <div className="gorups_profiles_view">
                                   <div className="gorups_profiles_view_pic group_over1">
                                      <div className="gorups_pro_pic_22"> 
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/face2.webp" alt="group member" title='group member'/>
                                      </div> 
                                      <div className="gorups_pro_pic_22 group_over2"> 
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/face3.webp" alt="group member" title='group member'/>
                                      </div>
                                      <div className="gorups_pro_pic_22 group_over3"> 
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/face4.webp" alt="group member" title='group member'/>
                                      </div>
                                   </div>
                                   <div className="gorups_profiles_view_text R14_42"> Sandeep and 2 friends are members</div>
                                </div> 
                                <div className="btn_group_join_common desktop_width_360">
                                  <a href='https://parenting.firstcry.com/groups/'  tabIndex={0} aria-label='join group'>
                                  <button className="M16_white" type="button" aria-hidden="true" tabIndex={-1}> JOIN </button>
                                  </a>
                                </div>
                                </div>
                            </div>
                        </div>
                        </div>
                     </section>
    )
}
